/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { etoilePercentage } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_multi_003: Question = {
  id: 'multi-003-proximite-residences-nature',
  oldId: '64',
  title: 'Proximité des résidences à la nature',
  number: '5.3',
  description: ['Proportion de résidents vivant à moins de 300m d\'une aire de conservation aménagée ou d\'un parc urbain si sa superficie est couverte à plus de 50% par de la végétation haute'],
  type: QuestionType.INDICATOR,
  frequency: 1,
  slots: [
    {
      type: SlotTypes.ETOILES,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: true,
      scoringFct: (data:number) => {
        if (data >= 41) return 3;
        if (data >= 26) return 2;
        if (data >= 11) return 1;
        return 0;
      },
      score: '0',
      maxScore: 3,
      labels: ['0% - 10%', '11% - 25%', '26% - 40 %', '+ de 40 %'],
      help: etoilePercentage,
      unit: SlotUnit.PERCENTAGE,
    },
  ],
};

const question_multi_003__v3: Question = {
  ...question_multi_003,
  title: 'Proportion de lots résidentiels dans le \'\'périmètre urbain\'\' a moins de 300m de la nature.',
  number: '5.2',
};

export const question_multi_003_v2: Question = question_multi_003;
export const question_multi_003_v3: Question = question_multi_003__v3;
